import { configureStore } from "@reduxjs/toolkit";

import cartReducer from "@zenith/features/Payments/components/ItemDetailsForm/item-details-form-component/cartSlice";

export const store = configureStore({
  reducer: {
    cart: cartReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
